import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Stack,
  IconButton,
  TextField,
  Button,
  Divider,
  Chip,
  Tooltip,
  Snackbar,
  LinearProgress,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import RoomIcon from "@mui/icons-material/Room";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PublicIcon from "@mui/icons-material/Public";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import RefreshIcon from "@mui/icons-material/Refresh";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { LoadingButton } from "@mui/lab";
import db from "../db";
import {
  getBrowserAndOS,
  getPublicIP,
  fetchAddressFromCoordinates,
  handleSync,
  pingServer,
  getDeviceStationId,
  isRealPhone ,
} from "../utils/global_functions";

import Visit from "./Visit";
import EmployeeStatus from "./EmployeeStatus";
// import { json } from "express";

import { apiFetch } from "../utils/apiFetch";

import axios from "axios";
import dayjs from "dayjs";
import {
   generateMonthDates,
  mapAttendanceRows,
} from "../utils/attendanceUtils";

import { SupervisorUid } from "./constants";
// to navigate through myattpage(to open my attendance and automatic filter on missing and incomplete days )
import { useNavigate } from "react-router-dom";


export default function FingerprintScanner() {
  const API_BASE_URL =
    localStorage.getItem("saved_sett_api_url") || "http://localhost:5100";

   //visit component 
  const empId = localStorage.getItem("shared_empid") || "default"
  const VISIT_STORAGE_KEY = `fingerprint_visit_state_${empId}`;
  //Random nb when an employee login for the first time ! 
  const stationId = getDeviceStationId();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [location, setLocation] = useState(null);
  const [showCameraFallback, setShowCameraFallback] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [comment, setComment] = useState("");
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);

  const [incompleteCount, setIncompleteCount]= useState(0);
  const [missingCount, setMissingCount] = useState(0);

  const fileInputRef = useRef(null);
  const fallbackTimerRef = useRef(null);

   // to transform empid to uid 
   const [currentEmpId, setCurrentEmpId] = useState("");

   // for dialog (missing and incomplete records)
   const navigate = useNavigate();
   const [issuesOpen, setIssuesOpen] = useState(false);
   const [empResolved, setEmpResolved] = useState(false);
   const issuesShownRef = useRef(false);

  //visit component 
  //make it to read from localstorage
  const [visitOn,setVisitOn]=useState(() => {
    try {
      const saved = localStorage.getItem(VISIT_STORAGE_KEY);
      if (!saved) return false;
      return JSON.parse(saved).visitOn ?? false;
    }catch {
      return false;
    }
  });
  const [visitData,setVisitData] = useState(() => {
    try {
      const saved= localStorage.getItem(VISIT_STORAGE_KEY);
      if (!saved) return { visitFrom: "", visitTo: "", amount: "", km: "", parking: "" };
      return JSON.parse(saved).visitData ?? { visitFrom: "", visitTo: "", amount: "", km: "", parking: "" };
    }catch {
      return { visitFrom: "", visitTo: "", amount: "", km: "", parking: "" };
    }
});


  useEffect(() => {
  const checkIncomplete = async () => {
    if (!API_BASE_URL || !empId) return;
    try {
      const today = dayjs();

      const res = await axios.get(`${API_BASE_URL}/api/attendance`, {
        params: { androidId: empId, month: today.month() + 1, year: today.year() },
      });

      const { data, AcceptedLeave } = res.data || {};
      const monthDates = generateMonthDates(today);
      const mappedRows = mapAttendanceRows(monthDates, data || [], AcceptedLeave || []);

      const count = mappedRows.filter((r) => isIncompleteTime(r.time, r.date)).length;
      setIncompleteCount(count);

      const missing = mappedRows.filter((r) => isMissingRecord(r)).length; // ✅ NEW
      setMissingCount(missing); // ✅ NEW

    } catch (e) {
      console.error("Failed to check incomplete days:", e); // ⬅ temporarily log this to confirm it's fixed
    }
  };
  checkIncomplete();
}, [API_BASE_URL, empId]);


  // Track online/offline for UI chip
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);
  

  //to saved final changes
  useEffect(() =>{
    try {
      localStorage.setItem(VISIT_STORAGE_KEY, JSON.stringify({ visitOn, visitData})); 
    }catch (e) {
      console.error("Failed to save visit state:", e);
    }
  }, [visitOn, visitData]);

  // Cleanup blob URL on change/unmount
  useEffect(() => {
    return () => {
      if (capturedImage && capturedImage.startsWith("blob:")) {
        URL.revokeObjectURL(capturedImage);
      }
    };
  }, [capturedImage]);


  useEffect(() => {
  if (!API_BASE_URL) return;
  const uid = localStorage.getItem("saved_username") || "";
  if (!uid) return;

  axios
    .get(`${API_BASE_URL}/api/resolve-empid`, { params: { uid } })
    .then((res) => setCurrentEmpId(String(res.data?.empId ?? "")))
    .catch(() => setCurrentEmpId(""))
    .finally(() => setEmpResolved(true));
}, [API_BASE_URL]);

  useEffect(() => {
    //already shown on this visit, so don’t reopen after Close.
    if (issuesShownRef.current) return;
    //wait until we know who the employee is
    if (!empResolved) return;
    //supervisors never see it.
    if (SupervisorUid.includes(currentEmpId)) return;
    //only when there’s something to fix.
    if (incompleteCount > 0 || missingCount > 0) {
      issuesShownRef.current = true;
      setIssuesOpen(true);
    }
  }, [incompleteCount, missingCount, currentEmpId, empResolved]);

  

  const clearFallbackTimer = () => {
    if (fallbackTimerRef.current) {
      clearTimeout(fallbackTimerRef.current);
      fallbackTimerRef.current = null;
    }
  };

  // TRIGGERS THE SYNC
  const handleFingerprintClick = async () => {
    const now = new Date();
    setError("");

    // If Visit mode is on, both From and To must be filled before we proceed
    if (visitOn) {
      const from = (visitData.visitFrom || "").trim();
      const to = (visitData.visitTo || "").trim();
      if (!from || !to) {
        setSnack({
          open: true,
          message: "Visit mode is on - please fill both From and To before tapping.",
          severity: "warning",
        });
        return;
      }
    }
    setLoading(true);
    setLocation(null);
    setCapturedImage(null);
    setShowCameraFallback(false);

    // Fallback in 60 seconds if GPS/address fails
    clearFallbackTimer();
    fallbackTimerRef.current = setTimeout(() => {
      setShowCameraFallback(true);
      setLoading(false);
    }, 60000);

    if (!navigator.geolocation) {
      setError("Geolocation not supported.");
      setShowCameraFallback(true);
      setLoading(false);
      clearFallbackTimer();
      return;
    }
    //* Step 1: get Gps location 
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        clearFallbackTimer();

        const { latitude, longitude } = position.coords;
        let address = "Unknown location";
       //* step2: get address from coordinates
        try {
          if (navigator.onLine) {
            address = await fetchAddressFromCoordinates(latitude, longitude);
          }
        } catch (e) {
          setError("Online, but failed to fetch address.");
          setShowCameraFallback(true);
          setLoading(false);

          return;
        }

        const confirm_date = now.toISOString().split("T")[0];
        const confirm_time = now.toTimeString().split(" ")[0];
        const mobileNumber = localStorage.getItem("saved_sett_mobilenumber");
        const full_name = localStorage.getItem("saved_sett_fullname");
        const device_name = getBrowserAndOS();
        const ip = await getPublicIP();
        const stationId =getDeviceStationId();
        const empId = localStorage.getItem("shared_empid");
        //* step 3: build the data object
        const transformed = [
          {
            mobileNumber,
            full_name,
            device_name,
            latitude,
            longitude,
            address,
            street: "",
            building: "",
            nearby: address,
            confirm_date,
            confirm_time,
            ip,
            filename: "",
            recordstatusid: 1,
            comment,
            empId,
            stationId,
            isPhone: isRealPhone(),
            confirm_type: 1,  //* 1: gps_submission , 3:manually , 2: zkMachine 
          },
        ];

        const fallbackData = { ...transformed[0] };

       
        // const isOnline=true;
        const isOnline = await pingServer(API_BASE_URL);
        try {
          // mhmd dakdouki
          // if (isOnline) {
          //   //* Step 4a : Online -> save to IndexDB first, then sync to server 
          //   const id = await db.attendance.add(fallbackData); //ToDo save locally 
          //   await handleSync(transformed, id);     //ToDo send to server , post /api/location/confirm(test.csc)
          //   setSnack({ open: true, message: "Attendance submitted.", severity: "success" });
          // } else {
            //262506, to duplicate record 
            if (isOnline) {
              const id = await db.attendance.add(fallbackData);
              console.log("[DEBUG] visitOn:", visitOn, "visitFrom:", visitData.visitFrom, "visitTo:", visitData.visitTo);
              //* If visit to == ACI force it to save 1 record instead of two ! 
              //const isReturningToAci = (visitData.visitTo || "").trim().toUpperCase() === "ACI";
              // pass visitFrom so backend knows whether to save 1 or 2 records
              // const empId = localStorage.getItem("shared_empid");
              // const returnedToAci = localStorage.getItem(`returned_to_aci_${empId}`) === "true";

              // if employee just returned to ACI, next normal tap needs 2 records
              // pass returnedToAci as a special flag — clear it after this tap
              // if (returnedToAci) {
              //   localStorage.removeItem(`returned_to_aci_${empId}`);
              // }
              await handleSync(transformed, id, visitOn && (!!visitData.visitFrom || !!visitData.visitTo) , visitData.visitFrom , visitData.visitTo);
              // await handleSync(transformed, id, visitOn && !!visitData.client);

              if (visitOn && visitData.visitFrom && visitData.visitTo) {
                // const empId = localStorage.getItem("shared_empid");
                try {
                  // const stationId = getDeviceStationId();

                  await apiFetch(`${API_BASE_URL}/api/visit`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      empId,
                      visitFrom: visitData.visitFrom,
                      visitTo:   visitData.visitTo,
                      date: confirm_date,
                      time: confirm_time,
                      amount: visitData.amount,
                      km: visitData.km,
                      parking: visitData.parking,
                      comment,
                      stationId,
                      isPhone: isRealPhone(),
                    }),
                  });
                  setSnack({ open: true, message: "Attendance + visit submitted.", severity: "success" });
                  // ── Special case: client "ACI" auto-turns Visit mode off right
                  // after this tap completes, resetting visit fields back to empty
                  // (same as a normal client-change reset). The tap itself already
                  // saved correctly above WHILE Visit was still on — this only
                  // affects what happens to the toggle/fields AFTER that save.
                  // const clientName = String(visitData.client?.name || "").trim().toLowerCase();
                  // if (clientName ==="aci") {
                  //   setVisitOn(false);
                  //   setVisitData({ client:null, amount: "",km: "",parking: ""});
                  // }
                  //* clear per-tap fields so a used amount/km/parking never carries over
                  // to the next visit - only From/To persist (From gets auto-suggested
                  // again anyway on next tap)
                  setVisitData((prev) => ({ ...prev, amount: "", km: "", parking: "" }));


                  // debug
                  console.log("[DEBUG] visitTo:", visitData.visitTo);
                  console.log("[DEBUG] toUpperCase:", (visitData.visitTo || "").trim().toUpperCase());
                  console.log("[DEBUG] is Company?", (visitData.visitTo || "").trim().toUpperCase() === "COMPANY");

                 const visitFromUpper = (visitData.visitFrom || "").trim().toUpperCase();
                 const visitToUpper   = (visitData.visitTo   || "").trim().toUpperCase();

                 if (visitFromUpper === "COMPANY" && visitToUpper === "COMPANY") {
                  setVisitOn(false);
                  setVisitData({ visitFrom: "", visitTo: "", amount: "", km: "", parking: "" });

                  //! flag: next normal tap should save 2 records (employee just arrived at ACI)
                  localStorage.setItem(`returned_to_aci_${empId}`, "true");
                }
                } catch (visitErr) {
                  console.error("Visit save failed:", visitErr);
                  setSnack({ open: true, message: "Attendance saved, but visit details failed to save.", severity: "warning" });
                }
              } else {
                setSnack({ open: true, message: "Attendance submitted.", severity: "success" });
              }
            } else {
            //* Step 4b: Offline -> save to IndexDB only
            await db.attendance.add(fallbackData);
            setSnack({ open: true, message: "Saved offline. Will sync later.", severity: "info" });
          }
        } catch (e) {
          console.error("[DEBUG] Actual error:", e);
          setSnack({ open: true, message: "Failed to save submission.", severity: "error" });
        }

        setLocation({
          latitude,
          longitude,
          address,
          confirm_date,
          confirm_time,
          ip,
        });

        setLoading(false);

        // auto-refresh page after 2 seconds so new records appear immediately
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      },
      () => {
        clearFallbackTimer();
        setError("Failed to get GPS location.");
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 45000, maximumAge: 0 }
    );
  };

  const handleImageSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLoading(true);
    setError("");

    const now = new Date();
    const confirm_date = now.toISOString().split("T")[0];
    const confirm_time = now.toTimeString().split(" ")[0];

    const mobileNumber = localStorage.getItem("saved_sett_mobilenumber");
    const full_name = localStorage.getItem("saved_sett_fullname");
    const device_name = getBrowserAndOS();
    const ip = await getPublicIP();
    const stationId = getDeviceStationId();
    const empId = localStorage.getItem("shared_empid");

    const latitude = "";
    const longitude = "";
    const address = "Camera-based entry";

    const uniqueId = now.toISOString().replace(/[-:.TZ]/g, "");
    const filename = `${mobileNumber}_${uniqueId}.jpg`;

    // Read file as base64
    const imageData = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const transformed = [
      {
        mobileNumber,
        full_name,
        device_name,
        latitude,
        longitude,
        address,
        street: "",
        building: "",
        nearby: address,
        confirm_date,
        confirm_time,
        ip,
        comment,
        confirm_type: "image",
        filename,
        file_base64: imageData,
        empId,
        stationId,
        isPhone: isRealPhone(),
      },
    ];

    const fallbackData = { ...transformed[0] };

    const isOnline = await pingServer(API_BASE_URL);
    try {
      if (isOnline) {
        await handleSync(transformed);
        setSnack({ open: true, message: "Image submitted.", severity: "success" });
      } else {
        await db.attendance.add(fallbackData);
        setSnack({ open: true, message: "Image saved offline. Will sync later.", severity: "info" });
      }
    } catch {
      setSnack({ open: true, message: "Failed to save image submission.", severity: "error" });
    }

    setCapturedImage(URL.createObjectURL(file));
    setLoading(false);
  };

  const isIncompleteTime = (timeStr, dateStr) =>{
    if (!timeStr) return false;
    if (!dateStr || !dayjs(dateStr).isBefore(dayjs(), "day")) return false;

    const s = String(timeStr).trim();

    if (s.includes(",") && !s.includes("~")) {
    const parts = s.split(",").map((p) => p.trim()).filter(Boolean);
    if (parts.length >= 2) return false;
  }

  const parts = s.split(",").map((p) => p.trim());
  return parts.some((p) => !p.includes("~") && !p.includes(","));
};

const isMissingRecord = (row) => {
  if (!row?.date) return false;
  if (!dayjs(row.date).isBefore(dayjs(), "day")) return false; // only days before today

  if (row.status === "Weekend") return false; // scheduled day off
  if (typeof row.status === "string" && row.status.startsWith("Vacation")) return false;
  if (row.isLeave) return false;

  const t = String(row.time || "").trim();
  return !t || t === "-" || t === "—";
};

  const header = (
    <Stack alignItems="center" spacing={1} sx={{ mb: 2 }}>
      <Typography
  variant="h5"
  sx={{
    fontWeight: 800,
    color: "#004d40",
    display: "flex",
    alignItems: "baseline",
    gap: 0.6,
  }}
>
  Attendance
  <Typography
    component="span"
    variant="body2"
    sx={{
      fontWeight: 500,
      fontSize: "0.8rem",
      color: "text.secondary",
    }}
  >
    (v{process.env.REACT_APP_VERSION || "1.0.0"})
  </Typography>

</Typography>
      <Typography variant="body2" color="text.secondary">
        Tap to capture GPS and time. If GPS is slow, use the camera fallback.
      </Typography>

      {/* {incompleteCount > 0 &&  !SupervisorUid.includes(currentEmpId) &&  (
        <Alert
          severity="error"
          sx={{
            backgroundColor: "#ffeaea",
            width: "100%",
            maxWidth: 480,
            py: { xs: 0.25, sm: 1 },
            px: { xs: 1, sm: 2 },
            "& .MuiAlert-message": {
              fontSize: { xs: 11, sm: 14 },
              lineHeight: { xs: 1.3, sm: 1.5 },
            },
            "& .MuiAlert-icon": {
              fontSize: { xs: 16, sm: 22 },
              py: { xs: 0.25, sm: 1 },
              mr: { xs: 0.75, sm: 1 },
            },
          }}
        >
          You have {incompleteCount} incomplete day{incompleteCount > 1 ? "s" : ""} before today. Please verify your attendance times.
        </Alert>
      )}

      {missingCount > 0 &&  !SupervisorUid.includes(currentEmpId) &&  (
        <Alert
          severity="warning"
          sx={{
            backgroundColor: "#fff8e1",
            width: "100%",
            maxWidth: 480,
            py: { xs: 0.25, sm: 1 },
            px: { xs: 1, sm: 2 },
            "& .MuiAlert-message": {
              fontSize: { xs: 11, sm: 14 },
              lineHeight: { xs: 1.3, sm: 1.5 },
            },
            "& .MuiAlert-icon": {
              fontSize: { xs: 16, sm: 22 },
              py: { xs: 0.25, sm: 1 },
              mr: { xs: 0.75, sm: 1 },
            },
          }}
        >
          You have {missingCount} working day{missingCount > 1 ? "s" : ""} before today with no attendance or leave record at all. Please check.
        </Alert>
      )} */}

      {/* <Chip
        label={online ? "Online" : "Offline"}
        color={online ? "success" : "warning"}
        size="small"
        sx={{ fontWeight: 700 }}
        // sx={{
        //   fontWeight: 700,
        //   fontSize: { xs: 10, sm: 13 },
        //   height: { xs: 20, sm: 24 },
        // }}
      /> */}
    </Stack>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        p: 2,
        pt: 4,
        background: {
          xs: "linear-gradient(180deg, #e0f2f1 0%, #ffffff 40%)",
          md: "linear-gradient(135deg, #e0f2f1 0%, #ffffff 55%)",
        },
      }}
    >
      <Card
        elevation={12}
        sx={{
          width: "100%",
          maxWidth: 760,
          borderRadius: 4,
          bgcolor: "rgba(255,255,255,0.95)",
          boxShadow: "0 20px 60px rgba(0,0,0,.12)",
          p: { xs: 2, md: 3 },
          border: "1px solid #b2dfdb",
        }}
      >
        {(loading) && <LinearProgress color="success" sx={{ mb: 1, borderRadius: 1 }} />}
        {header}

        <Stack alignItems="center" spacing={2}>
          <EmployeeStatus online={online}/>
          <Visit
            VisitOn={visitOn}
            VisitOnChange={setVisitOn}
            VisitData={visitData}
            onVisitDataChange={setVisitData}              
          />
          <Tooltip title="Submit attendance">
            <LoadingButton
              onClick={handleFingerprintClick}
              loading={loading}
              loadingIndicator={<CircularProgress size={26} />}
              sx={{
                position: "relative",
                borderRadius: "50%",
                width: 168,
                height: 168,
                background:
                  "radial-gradient(circle at 30% 30%, #0097a7 0%, #006064 60%)",
                boxShadow: "0 20px 40px rgba(0,0,0,.25)",
                "&:before": {
                  content: "''",
                  position: "absolute",
                  inset: -6,
                  borderRadius: "50%",
                  border: "2px solid rgba(0,150,136,.25)",
                  filter: "blur(0.5px)",
                },
                "&:hover": { filter: "brightness(1.05)" },
              }}
            >
              <FingerprintIcon sx={{ fontSize: 88, color: "white" }} />
            </LoadingButton>
          </Tooltip>

          <TextField
            label="Optional comment (saved with submission)"
            multiline
            rows={3}
            fullWidth
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            variant="outlined"
            sx={{
              maxWidth: 560,
              "& .MuiInputBase-root": {
                backgroundColor: "#fafafa",
                borderRadius: 2,
              },
            }}
          />

          <Stack direction="row" spacing={1}>
            {showCameraFallback ? (
              <Tooltip title="Use camera fallback">
                <IconButton
                  color="primary"
                  sx={{
                    backgroundColor: "#e3f2fd",
                    "&:hover": { backgroundColor: "#bbdefb" },
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <CameraAltIcon sx={{ fontSize: 32 }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Button
                size="small"
                startIcon={<CameraAltIcon />}
                onClick={() => setShowCameraFallback(true)}
              >
                Use camera instead
              </Button>
            )}

            {error && (
              <Button size="small" startIcon={<RefreshIcon />} onClick={handleFingerprintClick}>
                Retry GPS
              </Button>
            )}
          </Stack>
        </Stack>

        {/* Hidden file input */}
        <input
          type="file"
          accept="image/*"
          capture="environment"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleImageSelect}
        />

        {error && (
          <Alert
            icon={<ErrorOutlineRoundedIcon fontSize="inherit" />}
            severity="error"
            sx={{ mt: 2 }}
          >
            {error}
          </Alert>
        )}

        {/* Result card */}
        {location && (
          <Card
            elevation={0}
            sx={{
              mt: 3,
              borderRadius: 3,
              border: "1px solid #e0f2f1",
              background: "linear-gradient(180deg, #ffffff 0%, #f8fffe 100%)",
            }}
          >
            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                <CheckCircleRoundedIcon color="success" />
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                  Entry captured
                </Typography>
                <Chip
                  label={online ? "Online" : "Offline"}
                  size="small"
                  color={online ? "success" : "warning"}
                  sx={{ ml: "auto", fontWeight: 700 }}
                />
              </Stack>

              {capturedImage ? (
                <Box sx={{ mt: 2, textAlign: "center" }}>
                  <img
                    src={capturedImage}
                    alt="Captured"
                    style={{ width: "48%", borderRadius: 12 }}
                  />
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body2" color="text.secondary">
                    Image linked to this submission.
                  </Typography>
                </Box>
              ) : (
                <>
                  <Table size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, width: 180 }}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <PublicIcon fontSize="small" />
                            IP Address
                          </Stack>
                        </TableCell>
                        <TableCell>{location.ip}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <RoomIcon fontSize="small" />
                            Latitude
                          </Stack>
                        </TableCell>
                        <TableCell>{location.latitude}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <RoomIcon fontSize="small" />
                            Longitude
                          </Stack>
                        </TableCell>
                        <TableCell>{location.longitude}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>Address</TableCell>
                        <TableCell>{location.address}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <AccessTimeIcon fontSize="small" />
                            Confirm Date
                          </Stack>
                        </TableCell>
                        <TableCell>{location.confirm_date}</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <AccessTimeIcon fontSize="small" />
                            Confirm Time
                          </Stack>
                        </TableCell>
                        <TableCell>{location.confirm_time}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>

                  {(location.latitude || location.longitude) && (
                    <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<MyLocationIcon />}
                        onClick={() => navigator?.clipboard?.writeText(`${location.latitude},${location.longitude}`)}
                      >
                        Copy coords
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<OpenInNewIcon />}
                        href={`https://maps.google.com/?q=${location.latitude},${location.longitude}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Open in Maps
                      </Button>
                    </Stack>
                  )}
                </>
              )}
              
            </CardContent>
          </Card>
        )}

        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          message={snack.message}
        />
      </Card>
      {/* <Dialog
        open={issuesOpen}
        onClose={() => setIssuesOpen(false)}
        fullScreen
        slotProps={{ backdrop: { sx: { backgroundColor: "transparent" } } }}
        PaperProps={{
          sx: {
            backgroundColor: "rgba(195, 212, 212, 0.88)",
            backdropFilter: "blur(1px)",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 420, borderRadius: 4}}>
          <DialogContent>
            <Typography variant="h6" fontWeight={800} sx={{ color: "#004d40", mb: 1.5, textAlign: "center" }}>
              Check your attendance
            </Typography>
            <Stack spacing={1.2}>
              {incompleteCount > 0 && (
                <Alert severity="error" sx={{ borderRadius: 2 }}>
                  You have {incompleteCount} incomplete day{incompleteCount > 1 ? "s" : ""} before today.
                </Alert>
              )}
              {missingCount > 0 && (
                <Alert severity="warning" sx={{ borderRadius: 2 }}>
                  You have {missingCount} working day{missingCount > 1 ? "s" : ""} before today with no attendance or leave record.
                </Alert>
              )}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
            <Button onClick={() => setIssuesOpen(false)} sx={{ color: "#00796b", fontWeight: 700 }}>
              Close
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setIssuesOpen(false);
                navigate("/home/calendar?filter=issues");
              }}
              sx={{ backgroundColor: "#00796b", fontWeight: 700, borderRadius: 2, "&:hover": { backgroundColor: "#004d40" } }}
            >
              Show these days
            </Button>
          </DialogActions>
        </Box>
      </Dialog> */} 
      <Dialog
        open={issuesOpen}
        onClose={() => setIssuesOpen(false)}
        fullScreen
        slotProps={{ backdrop: { sx: { backgroundColor: "transparent" } } }}
        sx={{ "& .MuiDialog-container": { width: "100vw", height: "100vh" } }}
        PaperProps={{
          sx: {
            m: 0,
            width: "100vw",
            maxWidth: "100vw",
            height: "100vh",
            maxHeight: "100vh",
            borderRadius: 0,
            boxShadow: "none",
            //backgroundColor: "rgba(232, 246, 244, 0.96)",
            backgroundColor: "rgba(195, 212, 212, 0.88)",
            backdropFilter: "blur(7px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
          },
        }}
      >
        <Stack spacing={2.5} alignItems="center" sx={{ width: "100%", maxWidth: 420, textAlign: "center" }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              bgcolor: "#ffffff",
              border: "1px solid #b2dfdb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AccessTimeIcon sx={{ fontSize: 36, color: "#00796b" }} />
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={800} sx={{ color: "#004d40" }}>
              Check your attendance
            </Typography>
            <Typography variant="body2" sx={{ color: "#4f6f6b", mt: 0.5 }}>
              Some days before today need your attention.
            </Typography>
          </Box>

          <Stack spacing={1.2} sx={{ width: "100%" }}>
            {incompleteCount > 0 && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{ px: 2, py: 1.5, borderRadius: 3, bgcolor: "rgba(211, 47, 47, 0.08)", border: "1px solid rgba(211, 47, 47, 0.25)", textAlign: "left" }}
              >
                <Typography variant="h6" fontWeight={800} sx={{ color: "#c62828", minWidth: 28 }}>
                  {incompleteCount}
                </Typography>
                <Typography variant="body2" sx={{ color: "#7f1d1d" }}>
                  incomplete day{incompleteCount > 1 ? "s" : ""} (missing time in or time out)
                </Typography>
              </Stack>
            )}
            {missingCount > 0 && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{ px: 2, py: 1.5, borderRadius: 3, bgcolor: "rgba(237, 108, 2, 0.08)", border: "1px solid rgba(237, 108, 2, 0.25)", textAlign: "left" }}
              >
                <Typography variant="h6" fontWeight={800} sx={{ color: "#e65100", minWidth: 28 }}>
                  {missingCount}
                </Typography>
                <Typography variant="body2" sx={{ color: "#7c3a00" }}>
                  working day{missingCount > 1 ? "s" : ""} with no attendance or leave record
                </Typography>
              </Stack>
            )}
          </Stack>

          <Stack spacing={1} sx={{ width: "100%", pt: 1 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setIssuesOpen(false);
                navigate("/home/calendar?filter=issues");
              }}
              sx={{ py: 1.3, backgroundColor: "#00796b", fontWeight: 700, borderRadius: 3, textTransform: "none", fontSize: 15, boxShadow: "none", "&:hover": { backgroundColor: "#004d40", boxShadow: "none" } }}
            >
              Fix My Attendance
            </Button>
            <Button
              fullWidth
              onClick={() => setIssuesOpen(false)}
              //sx={{ py: 1.1, color: "#00796b", fontWeight: 700, borderRadius: 3, textTransform: "none", fontSize: 14 }}
              sx={{
                py: 1.1,
                color: "#00796b",
                fontWeight: 700,
                borderRadius: 3,
                textTransform: "none",
                fontSize: 14,
                transition: "all 0.2s ease",
                "&:hover": {
                  color: "#004d40",
                   backgroundColor: "rgba(22, 107, 96, 0.12)",
                },
                "&:hover .MuiTypography-root": {
                  color: "#004d40",
                },
              }}
            >
              <Stack alignItems="center" spacing={0}>
                <span>Not now</span>
                <Typography variant="caption" sx={{ color: "#4f6f6b", fontWeight: 600, lineHeight: 1.2 }}>
                  I Acknowledge
                </Typography>
              </Stack>

            </Button>
          </Stack>
        </Stack>
      </Dialog>

    </Box>
  );
}
